import {DataTableColumn} from "mantine-datatable";
import {ReconciliationReport} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {ChannelBadge, DiscrepancyBadge} from "../profile/Badges.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<ReconciliationReport>[] = [
        {
            accessor: 'channel',
            title: I18n.get('Channel'),
            width: '1fr',
            render: (item: ReconciliationReport) => <ChannelBadge channel={item.channel}/>,
        },
        {
            accessor: 'runDate',
            title: I18n.get('Run Date'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.runDate ?? '-',
        },
        {
            accessor: 'runStartedAt',
            title: I18n.get('Run Started'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.runStartedAt ? formatTimestamp(item.runStartedAt) : '-',
        },
        {
            accessor: 'runCompletedAt',
            title: I18n.get('Run Completed'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.runCompletedAt ? formatTimestamp(item.runCompletedAt) : '-',
        },
        {
            accessor: 'oursButNotTheirsCount',
            title: I18n.get('Ours Only'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.oursButNotTheirsCount ?? 0,
        },
        {
            accessor: 'theirsButNotOursCount',
            title: I18n.get('Theirs Only'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.theirsButNotOursCount ?? 0,
        },
        {
            accessor: 'quantityMismatchCount',
            title: I18n.get('Qty Mismatch'),
            width: '1fr',
            render: (item: ReconciliationReport) => item.quantityMismatchCount ?? 0,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: ReconciliationReport) => <DiscrepancyBadge record={item}/>,
        },
    ];

    return {
        columns,
    }
}
